var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-button',{attrs:{"type":_vm.type,"disabled":_vm.disabled,"loading":_vm.checkLoading},on:{"click":_vm.confirmCheckHandle}},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('ResultModal',{ref:"resultModalRef",attrs:{"title":_vm.$t('支付结果'),"errorMessageList":_vm.errorMessageList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }